module.exports = __webpack_public_path__ + "img/flagship.2b208237.jpg";